import {ProjectBudgetRes, ProjectRoleRes} from "../project.contract";
import {ProjectContractDetailRes} from "../project-contract.contract";
import {InvoiceDocumentFormat} from '../../../../enums/invoice-document-format';
import {TimesheetTemplate} from '../../../../enums/timesheet-template';
import {TimesheetSignee} from '../../../../enums/timesheet-signee';
import {TrackerDetailRes} from "./tracker.contract";
import {ToDoGroupRes} from "../todo.contract";
import {Type} from 'class-transformer';
import {InvoiceDetailRes} from '../../cp/invoice.contract';
import {BaseTaskRes, EffortType} from '../task';
import {UsedTimeRes} from '../../resource-manager/used-time';
import moment from "moment";
import {CompanyDetailsRes, CompanyMinimumRes} from '../../cp';
import {WorkflowDetailRes} from '../workflow.contract';

export class ProjectTrackerRes extends TrackerDetailRes {
    requireProjectBudget: boolean = false;

    @Type(() => WorkflowDetailRes)
    workflow!: WorkflowDetailRes;
    projectVolumeBrutto!: number;
    projectVolumeBruttoOpen!: number;
    billingPaymentTermsDays?: number | null;
    billingPaymentDiscountPercent?: number | null;
    billingPaymentDiscountDays?: number | null;
    billingPreferredInvoiceFormat?: InvoiceDocumentFormat | null;
    timesheetTemplate?: TimesheetTemplate | null;
    timesheetSignee?: TimesheetSignee | null;
    offerNr?: string;
    orderNr?: string;
    comment!: string;

    private _nextBill: any;
    get nextBill(): any {
        return this._nextBill;
    }

    set nextBill(value: any) {
        this._nextBill = value ? moment(value) : null;
    }

    @Type(() => CompanyDetailsRes)

    customer!: CompanyDetailsRes | CompanyMinimumRes;

    @Type(() => CompanyMinimumRes)

    timesheetCustomer?: CompanyMinimumRes | null;

    @Type(() => InvoiceDetailRes)
    invoices: InvoiceDetailRes[] = [];

    @Type(() => ProjectRoleRes)
    teamMembers: ProjectRoleRes[] = [];

    @Type(() => ProjectBudgetRes)
    budgets: ProjectBudgetRes[] = [];

    @Type(() => ProjectContractDetailRes)
    contracts: ProjectContractDetailRes[] = [];

    @Type(() => ToDoGroupRes)
    toDos: ToDoGroupRes | null = null;

    @Type(() => BaseTaskRes)
    tasks: BaseTaskRes[] = [];

    @Type(() => UsedTimeRes)
    usedTime: UsedTimeRes[] = [];

    @Type(() => EffortType)
    allowedEffortTypes: EffortType[] = [];

    sleeper!: boolean;

    color?: string;

    toMinRes() {
        const minRes = new ProjectMinRes();
        minRes.id = this.id;
        minRes.name = this.name;
        minRes.type = this.type;
        minRes.isActive = this.isActive;
        minRes.currentWorkflowStatus = this.currentWorkflowStatus;
        minRes.statusHistory = this.statusHistory;
        minRes.notes = this.notes;

        minRes.offerNr = this.offerNr;
        minRes.orderNr = this.orderNr;
        minRes.billingPaymentTermsDays = this.billingPaymentTermsDays ?? null;
        minRes.billingPaymentDiscountPercent = this.billingPaymentDiscountPercent ?? null;
        minRes.billingPaymentDiscountDays = this.billingPaymentDiscountDays ?? null;
        minRes.billingPreferredInvoiceFormat = this.billingPreferredInvoiceFormat ?? null;
        minRes.timesheetTemplate = this.timesheetTemplate ?? null;
        minRes.timesheetSignee = this.timesheetSignee ?? null;
        minRes.comment = this.comment;
        minRes.teamMemberCount = this.teamMembers?.length ?? 0;
        minRes.sleeper = this.sleeper;
        minRes.color = this.color;
        minRes.nextBill = this.nextBill;
        minRes.projectVolumeBrutto = this.projectVolumeBrutto;
        minRes.projectVolumeBruttoOpen = this.projectVolumeBruttoOpen;

        if (this.customer) {
            const customer = new CompanyMinimumRes();
            customer.id = this.customer.id;
            customer.name = this.customer.name;
            minRes.customer = customer;
        }

        if (this.timesheetCustomer) {
            const timesheetCustomer = new CompanyMinimumRes();
            timesheetCustomer.id = this.timesheetCustomer.id;
            timesheetCustomer.name = this.timesheetCustomer.name;
            minRes.timesheetCustomer = timesheetCustomer;
        }

        return minRes;
    }
}

export class ProjectMinRes extends TrackerDetailRes {
    requireProjectBudget: boolean = false;
    @Type(() => CompanyMinimumRes)
    customer!: CompanyMinimumRes;

    @Type(() => CompanyMinimumRes)
    timesheetCustomer?: CompanyMinimumRes | null;
    orderNr?: string;
    billingPaymentTermsDays?: number | null;
    billingPaymentDiscountPercent?: number | null;
    billingPaymentDiscountDays?: number | null;
    billingPreferredInvoiceFormat?: InvoiceDocumentFormat | null;
    timesheetTemplate?: TimesheetTemplate | null;
    timesheetSignee?: TimesheetSignee | null;
    offerNr?: string;
    comment?: string;
    teamMemberCount!: number;
    private _nextBill: any;

    get nextBill(): any {
        return this._nextBill;
    }

    set nextBill(value: any) {
        this._nextBill = value ? moment(value) : null;
    }

    projectVolumeBrutto!: number;
    projectVolumeBruttoOpen!: number;
    sleeper!: boolean;
    color?: string;
    start?: string;
    end?: string;
}